<template>
  <div class="FAQPage py-12 bg-gray-50 min-h-screen">
    <div class="wrapper max-w-4xl mx-auto px-4">
      <!-- Page Header -->
      <div class="text-center mb-12">
        <h1 class="text-4xl font-bold text-gray-800 mb-4">پرسیارە باوەکان</h1>
        <p class="text-lg text-gray-600">
          ئەمە لیستێکی تەواوی پرسیار و وەڵامە باوەکانی ئاگۆرا دەنگە
        </p>
      </div>

      <!-- FAQ Accordion -->
      <div class="space-y-4">
        <!-- FAQ Items from data -->
        <div
          v-for="faq in faqs"
          :key="faq.id"
          class="faq-item bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
        >
          <button
            @click="toggle(faq.id)"
            class="w-full px-6 py-5 flex items-center justify-between text-right hover:bg-gray-50 transition-colors"
          >
            <span class="text-lg font-medium">{{ faq.question }}</span>
            <span
              class="text-2xl text-teal-600 transition-transform duration-300"
              :class="{ 'rotate-45': open === faq.id }"
            >+</span>
          </button>
          <div
            v-if="open === faq.id"
            class="px-6 pb-6 text-gray-700 leading-relaxed"
            v-html="faq.answer"
          ></div>
        </div>
      </div>

      <!-- Still have questions section -->
      <div class="mt-16 bg-white rounded-3xl p-10 text-center shadow-sm">
        <h3 class="text-2xl font-semibold mb-4">هێشتا پرسیارت هەیە؟</h3>
        <p class="text-gray-600 mb-6">
          پەیوەندیمان پێوە بکە بۆ وەڵامدانەوەی هەموو پرسیارەکانت
        </p>
        <div>
          <div class="flex text-gray-700 text-center justify-center">
            <a
              href="tel:009647702000545"
              class="px-8 py-4 rounded-2xl transition text-lg"
            >٠٧٧٠٢٠٠٠٥٤٥</a>
            <br />
            <a
              href="tel:009647502000545"
              class="px-8 py-4 rounded-2xl transition text-lg"
            >٠٧٥٠٢٠٠٠٥٤٥</a>
          </div>
          <br />
          <a
            href="mailto:slaw@agoravision.com"
            class="bg-gray-800 text-white px-8 py-4 rounded-2xl hover:bg-gray-900 transition text-lg"
          >slaw@agoravision.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQPage",
  data() {
    return {
      open: null,

      faqs: [
        {
          id: 1,
          question: "١ - ئەپڵیکەیشنی ئاگۆرا دەنگ چییە؟",
          answer: `
            <p>ئاگۆرا دەنگ بریتیە لە یەکەمین ئەپڵیکەیشنی کتێبی دەنگیی کوردی، کە بە هەرسێ جۆری وێبسایت و ئەپلیکەیشنی ئەندرۆید و ئەپلیکەیشنی ئای ئۆ ئێس بەردەستە بۆ بەکارهێنان. لە ڕێگەی ئەم ئەپلیکەیشنەدا، دەتوانیت چەندین کتێبی دەنگیی دابەزێنیت و دوای بەکارهێنانی چەندین تایبەتمەندی ناو ئەپلیکەیشنەکە، بە کوالیتییەکی زۆر بەرز گوێ لە کتێبە دەنگییەکان بگریت. بۆ زانیاری زیاتر، سەردانی ئەم <a href="/#about" class="text-teal-600 hover:underline">بەستەرە</a> بکە.</p>
          `
        },
        {
          id: 2,
          question: "٢ - پەیوەندی نێوان ئاگۆرا دەنگ و کۆمپانیای ئاگۆرا ڤیژن چییە؟",
          answer: `
            <p>کۆمپانیای ئاگۆرا ڤیژن ئەو قەوارە یاساییەیە کە خاوەندارێتی و بەڕێوەبەرێتی ئەپڵیکەیشنی ئاگۆرا دەنگ دەکات. بۆ زانیاری زیاتر لەسەر کۆمپانیای ئاگۆرا ڤیژن، سەردانی ئەم <a href="https://www.agoravision.site/" target="_blank" class="text-teal-600 hover:underline">بەستەرە</a> بکە.</p>
          `
        },
        {
          id: 3,
          question: "٣ - ئەپڵیکەیشنی ئاگۆرا دەنگ بە چی زاراوەیەک بەردەستە؟",
          answer: `
            <p>لە ئێستادا ئاگۆرا دەنگ تەنها بە زاراوەی سۆرانی (کوردی ناوەڕاست) بەردەستە بەڵام لە کارکردنداین بۆ زیادکردنی بەرهەم و روکاری ئەپلیکەیشنەکە بە زاراوەکانی تریش لە داهاتوویەکی نزیکدا.</p>
          `
        },
        {
          id: 4,
          question: "٤ - چۆن ئەپڵیکەیشنی ئاگۆرا دەنگ بەکاربهێنم؟",
          answer: `
            <p>ئەتوانی بەم هەنگاوانەی خوارەوە ئەپڵیکەیشنەکە بەکار بهێنیت:</p>
            <p class="mt-2">١- دوای دابەزاندنی ئەپڵیکەیشنی ئاگۆرا دەنگ لە گوگڵ پلەی ستۆر یان ئەپڵ ئەپ ستۆر، کلیک لەسەر (بەردەوامبە) بکە.</p>
            <p class="mt-2">٢- بۆ بەکارهێنانی ئەپڵیکەیشنی ئاگۆرا دەنگ، بەکارهێنەر پێویستە هەژمارێکی خۆی لە ئەپڵیکەیشنەکەدا هەبێت. دەتوانیت بە هەژماری گوگڵ یان ئەپڵ یان فەیسبووک یان ئیمەیڵی تر چوونەژوورەوە بکەیت.</p>
            <p class="mt-2">٣- بۆ گوێگرتن لە سەرجەم بابەتەکان، پێویستە یەکێک لە پاکێجەکانی بەشداری کڕی بکەیت لە ڕێگەی گوگڵ پلەی یان ئەپڵ ئەپ ستۆرەوە.</p>
          `
        },
        {
          id: 5,
          question: "٥ - چۆن هەژمارێک دروست بکەم لە ئەپڵیکەیشنی ئاگۆرا دەنگ؟",
          answer: `
            <p>١- دوای دابەزاندنی ئەپڵیکەیشنی ئاگۆرا دەنگ، کلیک لەسەر (بەردەوامبە) بکە.</p>
            <p class="mt-2">٢- لەم لاپەڕەیەدا چوار هەڵبژاردەمان هەیە بۆ دروستکردنی هەژمار:</p>
            <ul class="list-disc list-inside mt-2 mr-4 space-y-1">
              <li>چوونەژوورەوە بە هەژماری گوگڵ</li>
              <li>چوونەژوورەوە بە هەژماری ئەپڵ</li>
              <li>چوونەژوورەوە بە هەژماری فەیسبووک</li>
              <li>چوونەژوورەوە بە ئیمەیڵ</li>
            </ul>
            <p class="mt-3">هەر یەکێک لەم هەڵبژاردانە بەکاربهێنە بۆ دروستکردنی هەژمار و چوونەژوورەوە بۆ ئەپڵیکەیشنەکە.</p>
          `
        },
        {
          id: 6,
          question: "٦ - من هەژمارم بە تەواوی کارا کردووە بەڵام بۆچی ناتوانم گوێ لە سەرجەم بابەتەکانی ناو ئاگۆرا دەنگ بگرم؟",
          answer: `
            <p>بۆ گوێگرتن لە سەرجەم بابەتەکانی ناو ئاگۆرا دەنگ، بەکارهێنەر پێویستە یەکێک لە پاکێجەکانی بەشداری کڕی بکات لە ڕێگەی گوگڵ پلەی ستۆر (بۆ ئەندرۆید) یان ئەپڵ ئەپ ستۆر (بۆ ئای ئۆ ئێس).</p>
            <p class="mt-2">بۆ کڕینی پاکێج، بچۆ بۆ بەشی (بەشداری) لە ناو ئەپڵیکەیشنەکەدا و یەکێک لە پاکێجەکان هەڵبژێرە.</p>
          `
        },
        {
          id: 7,
          question: "٧ - چەند پاکێجی بەشداری جیاواز هەیە لە ئەپڵیکەیشنی ئاگۆرا دەنگدا؟",
          answer: `
            <p>لە ئەپڵیکەیشنی ئاگۆرا دەنگدا سێ پاکێجی بەشداری هەیە:</p>
            <ul class="list-disc list-inside mt-3 mr-4 space-y-2">
              <li><strong>١ مانگ</strong> – ١٠،٥٠٠ دیناری عێراقی</li>
              <li><strong>٣ مانگ</strong> – ٢٤،٥٠٠ دیناری عێراقی</li>
              <li><strong>٦ مانگ</strong> – ٣٤،٥٠٠ دیناری عێراقی</li>
            </ul>
            <p class="mt-3 text-sm text-gray-600">تێبینی: نرخەکان لەوانەیە جیاواز بن لە کاتی کڕیندا بەپێی نرخی دیاریکراو لە گوگڵ پلەی یان ئەپڵ ئەپ ستۆر.</p>
          `
        },
        {
          id: 8,
          question: "٨ - چۆن پاکێجێک بکڕم؟",
          answer: `
            <p>بۆ کڕینی پاکێجی بەشداری، ئەم هەنگاوانە بکە:</p>
            <p class="mt-2">١- ئەپڵیکەیشنی ئاگۆرا دەنگ بکەرەوە و چوونەژوورەوە بکە بۆ هەژمارەکەت.</p>
            <p class="mt-2">٢- بچۆ بۆ بەشی (بەشداری) یان (پاکێجەکان) لە ناو ئەپڵیکەیشنەکەدا.</p>
            <p class="mt-2">٣- یەکێک لە پاکێجەکان هەڵبژێرە (١ مانگ، ٣ مانگ، یان ٦ مانگ).</p>
            <p class="mt-2">٤- کڕینەکە تەواو بکە لە ڕێگەی گوگڵ پلەی (بۆ ئەندرۆید) یان ئەپڵ ئەپ ستۆر (بۆ ئای ئۆ ئێس).</p>
            <p class="mt-3 text-sm text-gray-600">تێبینی: پێویستە شێوازی پارەدان (کارتی بانکی یان باڵانس) لە هەژماری گوگڵ یان ئەپڵەکەت زیاد کراو بێت.</p>
          `
        },
        {
          id: 9,
          question: "٩ - چۆن بەشداریکردنەکەم نوێ دەبێتەوە؟",
          answer: `
            <p>بەشداریکردنەکان بە شێوەیەکی ئۆتۆماتیکی نوێ دەبنەوە لە کاتی بوونی شێوازی پارەدانی کارا لە هەژماری گوگڵ پلەی یان ئەپڵ ئەپ ستۆرەکەت.</p>
            <p class="mt-2">ئەگەر نەتەویست بەشداریکردنەکەت نوێ ببێتەوە، دەتوانیت لە ڕێگەی ئەم هەنگاوانەوە هەڵیبوەشێنیتەوە:</p>
            <p class="mt-2"><strong>بۆ ئەندرۆید:</strong> گوگڵ پلەی ستۆر > مێنیو > بەشداریکردنەکان > ئاگۆرا دەنگ > هەڵوەشاندنەوە</p>
            <p class="mt-2"><strong>بۆ ئای ئۆ ئێس:</strong> ڕێکخستنەکان > ناوی ئەپڵ ئایدی > بەشداریکردنەکان > ئاگۆرا دەنگ > هەڵوەشاندنەوە</p>
          `
        },
        {
          id: 10,
          question: "١٠ - چۆن بەشداریکردنەکەم هەڵبوەشێنمەوە؟",
          answer: `
            <p>بۆ هەڵوەشاندنەوەی بەشداریکردن:</p>
            <p class="mt-3"><strong>بۆ ئەندرۆید:</strong></p>
            <p class="mr-4">١- گوگڵ پلەی ستۆر بکەرەوە</p>
            <p class="mr-4">٢- کلیک لەسەر ئایکۆنی پرۆفایل بکە</p>
            <p class="mr-4">٣- بچۆ بۆ "پارەدان و بەشداریکردنەکان" > "بەشداریکردنەکان"</p>
            <p class="mr-4">٤- ئاگۆرا دەنگ هەڵبژێرە و کلیک لەسەر "هەڵوەشاندنەوە" بکە</p>
            <p class="mt-3"><strong>بۆ ئای ئۆ ئێس:</strong></p>
            <p class="mr-4">١- بچۆ بۆ ڕێکخستنەکان (Settings)</p>
            <p class="mr-4">٢- کلیک لەسەر ناوەکەت بکە لە سەرەوە</p>
            <p class="mr-4">٣- بچۆ بۆ "بەشداریکردنەکان" (Subscriptions)</p>
            <p class="mr-4">٤- ئاگۆرا دەنگ هەڵبژێرە و کلیک لەسەر "هەڵوەشاندنەوە" بکە</p>
          `
        },
        {
          id: 11,
          question: "١١ - ئایا دەتوانم بەرهەمە دەنگیەکان دابگرم بۆ گوێگرتن لەکاتی نەبوونی ئینتەرنێتدا؟",
          answer: `
            <p>بەڵێ. بەکارهێنەر دەتوانێت بەرهەمە دەنگییەکان دابگرێت لە ئەپڵیکەیشنی ئاگۆرا دەنگدا و گوێیان لێبگرێت ئەگەر پەیوەستیش نەبێت بە هێڵی ئینتەرنێتەوە.</p>
            <p class="mt-2">بۆ دابەزاندنی بەرهەمێک، کلیک لەسەر ئایکۆنی دابەزاندن بکە لەتەنیشت هەر بابەتێک.</p>
          `
        },
        {
          id: 12,
          question: "١٢ - من نووسەر/ دانەر/ وەرگێڕی کتێبم. چۆن بتوانم بەرهەمەکانم بخەمە ئەپلیکەیشنی ئاگۆرا دەنگەوە؟",
          answer: `
            <p>ئێمە زۆرمان پێخۆشە و بەردەوامین لە زیادکردنی بەرهەمەکانی ئاگۆرا دەنگ. سوپاستان ئەکەین ئەگەر پەیوەندیمان پێوە بکەن لە ڕێگەی ئەم ڕێگایانەوە:</p>
            <ul class="list-disc list-inside mt-3 mr-4 space-y-1">
              <li>ئیمەیڵ: <a href="mailto:slaw@agoravision.com" class="text-teal-600 hover:underline">slaw@agoravision.com</a></li>
              <li>ژمارە مۆبایل: ٠٧٧٠٢٠٠٠٥٤٥ یان ٠٧٥٠٢٠٠٠٥٤٥</li>
            </ul>
          `
        },
        {
          id: 13,
          question: "١٣ - ئایا وەکو نووسەر/ دانەر/ وەرگێڕی کتێب چۆن مافەکانم پارێزراوە؟",
          answer: `
            <p>بەر لە بەکارهێنانی هەر بابەتێک، ئێمە پەیوەندی لەگەڵ نووسەر/ دانەر/ وەرگێڕی بابەتەکە دەکەین و بە فەرمی مافەکانی کۆمپانیا و نووسەر/ دانەر/ وەرگێڕ دەخرێتە گرێبەستی کارکردن.</p>
            <p class="mt-2">هەموو مافەکانی دارایی و مۆڵەتدانان بە ڕوونی لە گرێبەستەکەدا دیاری دەکرێن.</p>
          `
        },
        {
          id: 14,
          question: "١٤ - لە کاتی بوونی هەرپرسیارێکی تر یان کێشەیەک لە ئەپڵیکەشنی ئاگۆرا دەنگ پەیوەندی بە کێوە بکەم؟",
          answer: `
            <p>لە کاتی بوونی هەر کێشەو گرفتێکدا یان هەر پێشنیارو بیرۆکەیەک یان هەرپرسیارێکی تر کە لێرەدا وەڵامەکەی نییە، تکایە پەیوەندیمان پێوە بکە:</p>
            <ul class="list-disc list-inside mt-3 mr-4 space-y-2">
              <li>ژمارە مۆبایل: <a href="tel:009647702000545" class="text-teal-600 hover:underline">٠٧٧٠٢٠٠٠٥٤٥</a> یان <a href="tel:009647502000545" class="text-teal-600 hover:underline">٠٧٥٠٢٠٠٠٥٤٥</a></li>
              <li>ئیمەیڵ: <a href="mailto:slaw@agoravision.com" class="text-teal-600 hover:underline">slaw@agoravision.com</a></li>
            </ul>
          `
        }
      ]
    };
  },
  methods: {
    toggle(id) {
      this.open = this.open === id ? null : id;
    }
  }
};
</script>

<style scoped>
.faq-item {
  transition: all 0.3s ease;
}

.faq-item button {
  font-size: 1.05rem;
  line-height: 1.4;
}

.rotate-45 {
  transform: rotate(45deg);
}
</style>